<ng-container>
  <div class="log-metadata">
    <div class="v-center" style="gap: 8px;">
      <div class="log-metadata-time">{{log.eventCreated}}</div>
      <div class="log-metadata-category"> 
        <div class="badge playback-background">Playback Video</div>
      </div>
    </div>
    <div class="v-center" style="gap: 8px; flex-wrap: wrap">
      <div class="badge automation" *ngIf="isAutomationRule(log)" style="margin-left: 4px">Automation Action</div>
      <div class="badge verification-background" *ngIf="log.isHasVerification">Verification</div>
    </div>
    <div class="log-metadata-category">
      <ng-container *ngFor="let list of log.eventCodeList">
        <div class="badge xml-code">{{ list.code }}</div>
      </ng-container>
      <div class="log-metadata-device"> 
        <div class="log-metadata-device-zone" *ngIf="log.zone_number">{{log.zone_number}}</div>
        <div class="log-metadata-device-name" [class.no-name]="!log.name">{{log.name ?? 'No Name'}}</div>
      </div>
    </div>
    <div class="log-metadata-other">
      <div class="flex v-center" *ngIf="log.email" style="justify-content: end;">
        <div class="badge operator-viewed-background">Viewed </div>
        <div style="margin-left: 8px" *ngIf="!IPuserName">- {{log.email}}</div>
        <div style="margin-left: 8px" *ngIf="IPuserName">- {{IPuserName}} ({{log.ip}})</div>
      </div>
      <div>{{log.status_text}} by {{log.trigger}}</div>
      <div *ngIf="log?.partnerDescription">{{ log?.partnerDescription }}</div>
    </div>
  </div>
  <div class="loading-box" *ngIf="log.isLoading">
    <div class="loader absolute log-loader">
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path log-stroke-color" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
      </svg>
    </div>
  </div>
  <div class="flex" *ngIf="!log.isLoading && !isShowVideo" [ngSwitch]="canIShowImage()" style="justify-content: end;">
    <div [ngClass]="computedBackground()" *ngSwitchCase="'no permission'">No Permission</div>
    <div [ngClass]="computedBackground()" *ngSwitchCase="'need to upgrade plan'">Upgrade your dealer plan to access archived video.</div>
    <div [ngClass]="computedBackground()" *ngSwitchCase="'expired'">This video is expired</div>
    <div [ngClass]="computedBackground()" *ngSwitchCase="'privacy mode'">This camera is in privacy mode</div>
    <div [ngClass]="computedBackground()" *ngSwitchCase="'broken image'">Broken Image</div>
    <div class="v-center" [ngClass]="computedBackground()" *ngSwitchCase="'image'" style="position: relative; justify-content: center;" (click)="toggleToVideo($event)" (mouseenter)="mouseOverImage($event)" (mouseleave)="mouseLeaveImage($event)"><img [src]="log.imageUrl" (error)="isBrokenImage = true"/>
      <div class="play-btn" *ngIf="isShowPlayBtn"><i class="material-icons" style="color: white; font-size: 28px">play_arrow</i></div>
      <div class="hover-img" *ngIf="isShowPlayBtn"><img [src]="log.imageUrl" (load)="imgLoaded()" (error)="imgError($event)"/></div>
    </div>
    <div class="v-center" *ngSwitchDefault></div>
    <!-- nothing-->
  </div>
  <div class="flex" *ngIf="!log.isLoading && isShowVideo" [ngSwitch]="canIShowVideo()" style="justify-content: end;">
    <div [ngClass]="computedBackground()" *ngSwitchCase="'no permission'">No Permission</div>
    <div [ngClass]="computedBackground()" *ngSwitchCase="'expired'">This video is expired</div>
    <div [ngClass]="computedBackground()" *ngSwitchCase="'privacy mode'">This camera is in privacy mode</div>
    <div [ngClass]="computedBackground()" *ngSwitchCase="'broken video'">Broken Video</div>
    <div [ngClass]="computedBackground()" *ngSwitchCase="'video'" (click)="toggleToVideo($event)">
      <video [src]="log.safetyVideoUrl" controls="controls" autoplay="autoplay" muted="muted"></video>
    </div>
    <div class="v-center" *ngSwitchDefault></div>
    <!-- nothing-->
  </div>
</ng-container>